import { Injectable } from '@angular/core';

export type AppLauncherAuthMethod = 'email' | 'google';

@Injectable({ providedIn: 'root' })
export class GtmIdentityService {
	public pushAppLauncherIdentityReady(identity: {
		userId: string;
		email: string;
		authMethod: AppLauncherAuthMethod;
	}): void {
		const w = window as Window & { dataLayer?: Record<string, unknown>[] };
		w.dataLayer = w.dataLayer || [];
		w.dataLayer.push({
			event: 'app_launcher_identity_ready',
			app_launcher_user_id: identity.userId,
			app_launcher_email: identity.email,
			app_launcher_auth_method: identity.authMethod,
		});
	}
}
